import type {ReactNode} from 'react';

import {createContext, useContext, useRef, useState} from 'react';
import React from 'react';

import type {DialogProps, DialogRef} from '../components/Dialog';

import Dialog from '../components/Dialog';

type DialogContext = {
  closeDialog: () => void;
  openDialog: (content: DialogProps['children']) => void;
};

const DialogContext = createContext<DialogContext | null>(null);

type DialogProviderProps = {
  children: ReactNode;
};

export const DialogProvider = (props: DialogProviderProps) => {
  const {children} = props;
  const dialogRef = useRef<DialogRef>(null);
  const [dialogContent, setDialogContent] =
    useState<DialogProps['children']>(undefined);

  const openDialog: DialogContext['openDialog'] = (content) => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    setDialogContent(() => content);
    dialog.open({onClose: () => setDialogContent(undefined)});
  };

  const closeDialog = () => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    dialog.close();
  };

  return (
    <DialogContext.Provider value={{openDialog, closeDialog}}>
      <Dialog ref={dialogRef}>{dialogContent}</Dialog>
      {children}
    </DialogContext.Provider>
  );
};

export const useDialog = () => {
  const context = useContext(DialogContext);
  if (context) return context;
  throw new Error('useDialog should be used within DialogProvider');
};
